export function castStringToEnum<T>(enumObj: any, str: string | null | undefined): T | undefined {
  if (Object.values(enumObj).includes(str)) {
    return str as T;
  }
  return undefined;
}
